/**
 * Talewave tags config - copied from oceread
 */
import { tagsCommonConfig } from './common'

export const tagsConfig = {
  ...tagsCommonConfig,
}
